import React from 'react'
import { DataGrid } from "@mui/x-data-grid";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import "../list/List.css";

const List = (props) => {

  const applySearch=(e)=>{
    if(e.target.value.length > 2 || e.keyCode == 8 || e.keyCode == 13){
      props.setSearch(e.target.value);
      props.setCompanies([]);
    }
  }

  return (
    <div className="datalist">
      <input type="text" className="form-control" placeholder="search for..." onKeyUp={(e)=>applySearch(e)}/>
      <div class="list">
        <DataGrid
            getRowId={(row) => row.Id}
            rows={props.rows}
            columns={props.columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableColumnFilter
            disableColumnMenu 
            sx={{
              '.MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
            headerHeight={0}
            />
      </div>
        
    </div>
  );
};

export default List;